(async () => {
    showPreloader('#filter-shape');
    showPreloader('#filter-price');
    showPreloader('#filter-weight');
    showPreloader('#filter-color');
    showPreloader('#filter-cutGrade');
    showPreloader('#filter-clarity');
    showPreloader('#filter-lab');

    const priceRange = await getPriceRange({ vendor: ['Skylab', 'EcoLight'] });
    const weightRange = await getWeightRange({ vendor: ['Skylab', 'EcoLight'] });
    const filters = await getFilters({ vendor: ['Skylab', 'EcoLight'] });

    await loadProducts(productQuery);

    hideAllPreloaders();

    var filterShapeContainer = $('#filter-shape-container');

    var filterColorContainer = $('#filter-color-container');
    filters.color.forEach(filter => {
        var filterBox = $('<div>');
        filterBox.attr('data-filter_value', filter);
        filterBox.addClass('margin-0-05em').addClass('filter-list-item');
        filterBox.text(filter);
        filterColorContainer.append(filterBox);
    });

    var filterClarityContainer = $('#filter-clarity-container');
    filters.clarity.forEach(filter => {
        var filterBox = $('<div>');
        filterBox.attr('data-filter_value', filter);
        filterBox.addClass('margin-0-05em').addClass('filter-list-item');
        filterBox.text(filter);
        filterClarityContainer.append(filterBox);
    });

    var filterLabContainer = $('#filter-lab-container');
    filters.lab.forEach(filter => {
        var filterBox = $('<div>');
        filterBox.attr('data-filter_value', filter);
        filterBox.addClass('margin-0-05em').addClass('filter-list-item');
        filterBox.text(filter);
        filterLabContainer.append(filterBox);
    });

    var filterCutGradeContainer = $('#filter-cutGrade-container');
    cutList.forEach(filter => {
        var filterBox = $('<div>');
        filterBox.attr('data-filter_value', filter);
        filterBox.addClass('margin-0-05em').addClass('filter-list-item');
        filterBox.text(cutListObject[filter]);
        filterCutGradeContainer.append(filterBox);
    });

    // price range slider
    Object.entries(priceRange).forEach(([key, value]) => {;
        var input = $('#filter-price #' + key + '-value');
        input.val(value);
        input.attr(key, value);
    });

    console.log(priceRange);
    
    $("#price-range").slider({
        range: true,
        min: priceRange.minPrice,
        max: priceRange.maxPrice,
        values: [priceRange.minPrice, priceRange.maxPrice],
        step: 0.1,
        slide: function(event, ui) {
            // Оновлюємо відображення під час руху повзунка
            $("#price-amount").val("$" + ui.values[0] + " - $" + ui.values[1]);
            $('#filter-price #min-value').val(ui.values[0]);
            $('#filter-price #max-value').val(ui.values[1]);
        },
        stop: async function(event, ui) {
            // Викликаємо завантаження товарів лише після завершення переміщення
            page = 1;
            productQuery.page = page;
            productQuery.filter.price_from = ui.values[0];
            productQuery.filter.price_to = ui.values[1];

            await loadProducts(productQuery, true);
            $('.table-wrapper > table').scrollTop(0);
        }
    });
    $("#price-amount").val("$" + $("#price-range").slider("values", 0) + " - $" + $("#price-range").slider("values", 1));
    // end price range slider

    // weight range slider
    Object.entries(weightRange).forEach(([key, value]) => {
        var input = $('#filter-weight #' + key + '-value');
        input.val(value);
        input.attr(key, value);
    });
    
    $("#weight-range").slider({
        range: true,
        min: weightRange.minWeight,
        max: weightRange.maxWeight,
        values: [weightRange.minWeight, weightRange.maxWeight],
        step: 0.001,
        slide: function(event, ui) {
            // лише оновлюємо відображення
            $("#weight-amount").val(ui.values[0] + " - " + ui.values[1]);
            $('#filter-weight #min-value').val(ui.values[0]);
            $('#filter-weight #max-value').val(ui.values[1]);
        },
        stop: async function(event, ui) {
            // викликаємо завантаження товарів лише після завершення переміщення
            page = 1;
            productQuery.page = page;
            productQuery.filter.weight_from = ui.values[0];
            productQuery.filter.weight_to = ui.values[1];

            await loadProducts(productQuery, true);
            $('.table-wrapper > table').scrollTop(0);
        }
    });
    $("#weight-amount").val($("#weight-range").slider("values", 0).toFixed(2) + " - " + $("#weight-range").slider("values", 1).toFixed(2));
    // end weight range slider

    shapeBlocks = $('#filter-shape-container > *');
    shapeSortableBlocks = [];
    shapeNotSortableBlocks = [];
    $(shapeBlocks).each(function(index, value) {
        var i = shapeList.indexOf($(value).text().trim().toLowerCase());
        if (i != -1) {
            shapeSortableBlocks[i] = value;
        } else {
            shapeNotSortableBlocks.push(value);
        }
    });
    $('#filter-shape-container').html(shapeSortableBlocks);
    $('#filter-shape-container').append(shapeNotSortableBlocks);
    $('#filter-shape-container').show();
    // end sort shapes

    $('.table-wrapper > table').on('scroll', async function() {
        var container = $(this);
        console.log('scroll');
        if (!loading && container.scrollTop() + container.innerHeight() >= this.scrollHeight - 50) {
            loading = true;
            page++;
            productQuery.page = page;
            await loadProducts(productQuery);
            loading = false;
        }
    });

    $(document).ready(function() {
        var params = location.hash.replace('#', '').split('&');
        var shapeValues = false;
        params.forEach(function(param) {
            var param_val = param.split('=');
            var key = param_val[0];
            var values_str = param_val[1];
            if (key === 'shape') {
                shapeValues = values_str.split(',');
            }
        });
    });

    $(document).on('click', function(e) {
        e.preventDefault();
        target = $(e.target);
        var tr = $(e.target).closest('tr');
        if (tr.length && tr.attr('href')) {
            document.body.classList.add("unloading");
                var i = tr.attr('href');
                window.setTimeout((function() {
                    location.href = i
                }
            ), 50)
        }
    });

   filterShapeContainer.find('.filter-list-item').on('click', async function(e) {
        var filterItem = $(e.currentTarget);
        var filterValue = filterItem.attr('data-filter_value');

        if (!productQuery.filter) {
            productQuery.filter = {};
        }

        var isEnable = filterItem.hasClass('filter-enable');

        filterShapeContainer.find('.filter-enable').removeClass('filter-enable');

        if (isEnable) {
            delete productQuery.filter.shape;
            filterItem.removeClass('filter-enable');
        } else {
            productQuery.filter.shape = filterValue;
            filterItem.addClass('filter-enable');
        }

        page = 1;
        productQuery.page = page;

        console.log('Shape filter:', productQuery.filter.shape);
        await loadProducts(productQuery, true);
        $('.table-wrapper > table').scrollTop(0);
    });

   filterColorContainer.find('.filter-list-item').on('click', async function(e) {
        var filterItem = $(e.currentTarget);
        var filterValue = filterItem.attr('data-filter_value');

        if (!productQuery.filter) {
            productQuery.filter = {};
        }

        // Ініціалізація масиву для кольорів
        if (!Array.isArray(productQuery.filter.color)) {
            productQuery.filter.color = [];
        }

        var isEnable = filterItem.hasClass('filter-enable');

        if (isEnable) {
            // видаляємо цей колір з масиву
            productQuery.filter.color = productQuery.filter.color.filter(v => v !== filterValue);
            filterItem.removeClass('filter-enable');
        } else {
            // додаємо колір у масив
            productQuery.filter.color.push(filterValue);
            filterItem.addClass('filter-enable');
        }

        // Якщо масив порожній, видаляємо фільтр
        if (productQuery.filter.color.length === 0) {
            delete productQuery.filter.color;
        }

        // Скидаємо пагінацію
        page = 1;
        productQuery.page = page;

        console.log('color filter:', productQuery.filter.color);
        await loadProducts(productQuery, true);

        // Скролимо до початку таблиці
        $('.table-wrapper > table').scrollTop(0);
    });

    filterCutGradeContainer.find('.filter-list-item').on('click', async function(e) {
        var filterItem = $(e.currentTarget);
        var filterValue = filterItem.attr('data-filter_value');

        if (!productQuery.filter) {
            productQuery.filter = {};
        }

        // Ініціалізація масиву для кольорів
        if (!Array.isArray(productQuery.filter.cut_grade)) {
            productQuery.filter.cut_grade = [];
        }

        var isEnable = filterItem.hasClass('filter-enable');

        if (isEnable) {
            // видаляємо цей колір з масиву
            productQuery.filter.cut_grade = productQuery.filter.cut_grade.filter(v => v !== filterValue);
            filterItem.removeClass('filter-enable');
        } else {
            // додаємо колір у масив
            productQuery.filter.cut_grade.push(filterValue);
            filterItem.addClass('filter-enable');
        }

        // Якщо масив порожній, видаляємо фільтр
        if (productQuery.filter.cut_grade.length === 0) {
            delete productQuery.filter.cut_grade;
        }

        // Скидаємо пагінацію
        page = 1;
        productQuery.page = page;

        console.log('cut_grade filter:', productQuery.filter.cut_grade);
        await loadProducts(productQuery, true);

        // Скролимо до початку таблиці
        $('.table-wrapper > table').scrollTop(0);
    });

    filterLabContainer.find('.filter-list-item').on('click', async function(e) {
        var filterItem = $(e.currentTarget);
        var filterValue = filterItem.attr('data-filter_value');

        if (!productQuery.filter) {
            productQuery.filter = {};
        }

        // Ініціалізація масиву для кольорів
        if (!Array.isArray(productQuery.filter.lab)) {
            productQuery.filter.lab = [];
        }

        var isEnable = filterItem.hasClass('filter-enable');

        if (isEnable) {
            // видаляємо цей колір з масиву
            productQuery.filter.lab = productQuery.filter.lab.filter(v => v !== filterValue);
            filterItem.removeClass('filter-enable');
        } else {
            // додаємо колір у масив
            productQuery.filter.lab.push(filterValue);
            filterItem.addClass('filter-enable');
        }

        // Якщо масив порожній, видаляємо фільтр
        if (productQuery.filter.lab.length === 0) {
            delete productQuery.filter.lab;
        }

        // Скидаємо пагінацію
        page = 1;
        productQuery.page = page;

        console.log('lab filter:', productQuery.filter.lab);
        await loadProducts(productQuery, true);

        // Скролимо до початку таблиці
        $('.table-wrapper > table').scrollTop(0);
    });

    filterClarityContainer.find('.filter-list-item').on('click', async function(e) {
        var filterItem = $(e.currentTarget);
        var filterValue = filterItem.attr('data-filter_value');

        if (!productQuery.filter) {
            productQuery.filter = {};
        }

        // Ініціалізація масиву для кольорів
        if (!Array.isArray(productQuery.filter.clarity)) {
            productQuery.filter.clarity = [];
        }

        var isEnable = filterItem.hasClass('filter-enable');

        if (isEnable) {
            // видаляємо цей колір з масиву
            productQuery.filter.clarity = productQuery.filter.clarity.filter(v => v !== filterValue);
            filterItem.removeClass('filter-enable');
        } else {
            // додаємо колір у масив
            productQuery.filter.clarity.push(filterValue);
            filterItem.addClass('filter-enable');
        }

        // Якщо масив порожній, видаляємо фільтр
        if (productQuery.filter.clarity.length === 0) {
            delete productQuery.filter.clarity;
        }

        // Скидаємо пагінацію
        page = 1;
        productQuery.page = page;

        console.log('clarity filter:', productQuery.filter.clarity);
        await loadProducts(productQuery, true);

        // Скролимо до початку таблиці
        $('.table-wrapper > table').scrollTop(0);
    });

})();

